import SidebarContainer from './containers/SidebarContainer'

export default SidebarContainer
